/**
 * @generated SignedSource<<bb87c482be026b5c0ca5d8eb9a27703b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccessKnownRolesData$data = {
  readonly knownGroups: ReadonlyArray<{
    readonly assignableActions: ReadonlyArray<string>;
    readonly implies: ReadonlyArray<string>;
    readonly label: { default: string } & Record<string, string | undefined>;
    readonly role: string;
    readonly safeActions: ReadonlyArray<string>;
    readonly sortKey: string | null | undefined;
  }>;
  readonly " $fragmentType": "AccessKnownRolesData";
};
export type AccessKnownRolesData$key = {
  readonly " $data"?: AccessKnownRolesData$data;
  readonly " $fragmentSpreads": FragmentRefs<"AccessKnownRolesData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccessKnownRolesData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "KnownGroup",
      "kind": "LinkedField",
      "name": "knownGroups",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "role",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "implies",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sortKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "safeActions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignableActions",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "5c9ff230e6642b02c4f5bfe45f6610fb";

export default node;
